import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProcessFlow = ({ steps }) => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 lg:p-10">
      <h3 className="text-2xl md:text-3xl lg:text-4xl font-headline font-bold text-foreground mb-8 md:mb-10 lg:mb-12">
        Our Process
      </h3>
      <div className="hidden lg:block">
        <div className="relative">
          <div className="absolute top-12 left-0 right-0 h-0.5 bg-border" />
          <div 
            className="absolute top-12 left-0 h-0.5 bg-primary transition-all duration-500"
            style={{ width: `${(activeStep / (steps?.length - 1)) * 100}%` }}
          />

          <div className="relative grid grid-cols-5 gap-4">
            {steps?.map((step, index) => (
              <button
                key={index}
                onClick={() => setActiveStep(index)}
                className="flex flex-col items-center text-center group"
              >
                <div className={`w-24 h-24 rounded-full border-4 flex items-center justify-center mb-4 transition-all duration-300 ${
                  index <= activeStep 
                    ? 'bg-primary border-primary shadow-lg scale-110' 
                    : 'bg-card border-border group-hover:border-primary/50'
                }`}>
                  <Icon 
                    name={step?.icon} 
                    size={32} 
                    color={index <= activeStep ? 'var(--color-primary-foreground)' : 'var(--color-muted-foreground)'} 
                  />
                </div>
                <span className={`text-sm font-medium transition-colors duration-300 ${
                  index <= activeStep ? 'text-primary' : 'text-muted-foreground'
                }`}>
                  Step {index + 1}
                </span>
                <span className={`text-base font-headline font-semibold mt-1 transition-colors duration-300 ${
                  index === activeStep ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {step?.title}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 p-8 bg-muted rounded-xl">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={steps?.[activeStep]?.icon} size={24} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="text-xl font-headline font-bold text-foreground mb-2">
                {steps?.[activeStep]?.title}
              </h4>
              <p className="text-base text-muted-foreground">
                {steps?.[activeStep]?.description}
              </p>
            </div>
          </div>

          <div className="space-y-3 mt-6">
            {steps?.[activeStep]?.details?.map((detail, index) => (
              <div key={index} className="flex items-start gap-3">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span className="text-sm text-foreground">{detail}</span>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2 mt-6 pt-6 border-t border-border">
            <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground">
              Duration: {steps?.[activeStep]?.duration}
            </span>
          </div>
        </div>
      </div>
      <div className="lg:hidden space-y-4">
        {steps?.map((step, index) => (
          <div
            key={index}
            className="bg-muted rounded-xl p-6 border-l-4 border-primary"
          >
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={step?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <span className="text-xs font-medium text-primary mb-1 block">
                  Step {index + 1}
                </span>
                <h4 className="text-lg font-headline font-bold text-foreground">
                  {step?.title}
                </h4>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              {step?.description}
            </p>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
              <span className="text-xs text-muted-foreground">{step?.duration}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessFlow;